import { TaggedUserType } from "../../../slices/TicketSlice";

export function CallDescToTaggedDescriptionConverter(
  callDesc: string,
  taggedUsers: TaggedUserType[]
) {
  let newDesc = callDesc;
  taggedUsers.forEach((tag) => {
    if (callDesc.includes(tag.label)) {
      const newValue = newDesc.replace(tag.label, `[${tag.value}]`);
      newDesc = newValue;
    }
  });
  return newDesc;
}

export function ShowMentions(mentionsText: string, minChars: number) {
  return (
    mentionsText.length !== 0 &&
    mentionsText.length >= minChars &&
    mentionsText.length <= 6
  );
}
